import {useSuspenseApiQuery} from '@legit.health/backend-client';
import {generatePath, AnonymousDiagnosticReport, DiagnosticReportId} from '@legit.health/ui';
import {useParamsContext} from '@/contexts/ParamsContext';
import useLocale from '@/hooks/useLocale';

export default function useGetAnonymousDiagnosticReport({
  diagnosticReportId
}: {
  diagnosticReportId: DiagnosticReportId;
}) {
  const {companyApiKey} = useParamsContext();
  const locale = useLocale();
  return useSuspenseApiQuery<AnonymousDiagnosticReport>({
    queryOptions: {
      queryKey: ['anonymous-diagnostic-report', {diagnosticReportId, locale, companyApiKey}]
    },
    requestArguments: {
      method: 'GET',
      path: generatePath(
        '/anonymous-diagnostic-reports/:diagnosticReportId',
        {diagnosticReportId},
        {locale}
      )
    }
  });
}
